import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export async function getCarsByDatamaster(datamasterId, query) {
    const result = await axios.get(`${CATALOGO_ENDPOINT}/datamaster/${datamasterId}?${query}`)

    return result.data.data
}
 